import { h } from "preact";
import { connect } from "react-redux";
import { reduxForm, Field } from "redux-form";
import InputField from "./fields/InputField";
import Note from "../components/Note";
import {
  showAccessCodes,
  checkAccessCode,
  removeAccessCode
} from "../state/actions/ticketsActions";
import ActionButton from "./ActionButton";
import crossIcon from "../assets/images/icon-cross.svg";
import successIcon from "../assets/images/icon-success.svg";

let AccessCode = ({
  event,
  ticketSelection,
  showAccessCodes,
  checkAccessCode,
  removeAccessCode
}) => {
  if (!event.data.hasAccessCodes) {
    return null;
  }
  const ticketStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    fontSize: 14
  };
  const ticketWrap = {
    borderBottom: "1px solid #d9d9d9",
    padding: "17px 0"
  };
  const infoStyle = {
    flex: 1
  };

  return !ticketSelection.showAccessCode ? (
    <div style={ticketWrap}>
      <div style={ticketStyle}>
        <div>
          <a
            onClick={showAccessCodes}
            style={{
              margin: "18px 0 0 0",
              cursor: "pointer",
              textDecoration: "underline"
            }}
            data-cy="EnterAccessCode"
            href="#"
          >
            Access hidden tickets
          </a>
        </div>
      </div>
    </div>
  ) : (
    <AccessCodeForm
      event={event}
      ticketSelection={ticketSelection}
      removeAccessCode={removeAccessCode}
      checkAccessCode={checkAccessCode}
    />
  );
};

let AccessCodeForm = ({
  event,
  ticketSelection,
  handleSubmit,
  removeAccessCode,
  checkAccessCode
}) => {
  const save = values => {
    const code = values.accessCode;
    if (code) {
      checkAccessCode(event.data._id, code);
    }
  };
  const remove = () => {
    removeAccessCode();
  };
  const accessCodeStyle = {
    background: `url(${successIcon}) no-repeat left 5px center`,
    backgroundSize: 20,
    color: "#157e77",
    margin: "0px 12px",
    padding: "4px 0 4px 28px",
    display: "inline-block"
  };
  const removeStyle = {
    background: `url(${crossIcon}) no-repeat right 5px center`,
    backgroundSize: 20,
    paddingLeft: 30,
    cursor: "pointer",
    float: "right",
    height: 30
  };
  const accessStyle = {
    padding: "12px 0",
    borderBottom: "1px solid rgb(217, 217, 217)"
  };
  if (ticketSelection.accessCode) {
    return (
      <div style={accessStyle}>
        <span>
          Access password:{" "}
          <span style={accessCodeStyle}>{ticketSelection.accessCode}</span>
          <a onClick={remove} style={removeStyle} />
        </span>
      </div>
    );
  }

  return (
    <div style={accessStyle}>
      <form onSubmit={handleSubmit(save)}>
        <div
          style={{
            display: "flex"
          }}
        >
          <Field
            label="Access Code"
            style={{
              flex: "1"
            }}
            inputStyle={{
              borderRadius: "4px 0 0 4px"
            }}
            type="text"
            name="accessCode"
            component={InputField}
            placeholder="Code"
            autofocus={true}
          />
          <ActionButton
            loading={ticketSelection.accessCodeRequest.loading}
            classNames="btn-secondary"
            dataCY="AccessCodeApply"
            style={{
              borderRadius: "0 3px 3px 0",
              padding: "4px 10px",
              width: 150,
              marginTop: 24
            }}
          >
            Apply
          </ActionButton>
        </div>
        {ticketSelection.accessCodeRequest.error ? (
          <p class="text-error error-icon">
            {ticketSelection.accessCodeRequest.error}
          </p>
        ) : (
          ""
        )}
        <Note>Discount codes can be entered in the next step</Note>
      </form>
    </div>
  );
};

AccessCodeForm = reduxForm({ form: "accessCode" })(AccessCodeForm);

export default connect(
  state => ({ event: state.event, ticketSelection: state.ticketSelection }),
  { showAccessCodes, checkAccessCode, removeAccessCode }
)(AccessCode);



// WEBPACK FOOTER //
// ./components/AccessCode.js